
import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const PortfolioPage = lazy(() => import("../pages/portfolio/page"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/portfolio",
    element: <PortfolioPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/hakkimizda",
    element: <AboutPage />,
  },
  {
    path: "/iletisim",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
